import { CheckIcon, MinusIcon } from "@heroicons/react/20/solid"
import React from "react"
import { connect } from "react-redux"
import { Actions as FYORINACTIONS } from './store/fyorinActions'

import Logo from "./assets/fyorin-logo.svg"

const FyorinSettings = ({
    connected,
    needsVerification,
    connect,
    verifyConnection,
    disconnect
}) => {
    return (
        <div className="col-sm-12 integration-row">
            <div className="col-sm-3">
                <img src={Logo} width="40px" />
                <span style={{ paddingLeft: 20, fontSize: 16 }}>Fyorin</span>
            </div>
            <div className="col-sm-9">
                <button className="btn btn-primary pull-right" style={{ marginTop: 2 }} onClick={() => {
                    if (connected || needsVerification) {
                        disconnect()
                    } else {
                        connect()
                    }
                }
                }>
                    {connected || needsVerification ?
                        <>
                            <MinusIcon style={{ height: "1.5em", float: "left" }} />
                            <div style={{ float: "left", marginLeft: 5 }}>Disconnect</div>
                        </>
                        :
                        'Connect'
                    }
                </button>
                {(connected || needsVerification) &&
                    <button
                        className={`btn ${needsVerification ? 'btn-primary' : 'btn-default'} pull-right`}
                        style={{ marginTop: 2, marginRight: 10 }}
                        onClick={() => {
                            if (needsVerification) {
                                verifyConnection()
                            }
                        }}>
                        {needsVerification ? 'Verify Connection'
                            :
                            <>
                                <CheckIcon style={{ height: "1.5em", float: "left" }} />
                                <div style={{ float: "left", marginLeft: 5, marginRight: 5 }}>Connected</div>
                            </>
                        }
                    </button>
                }
            </div>
        </div >
    )
}

const mapStateToProps = (state) => {
    const { fyorin } = state?.integration?.payment || {}


    return {
        connected: !!fyorin,
        needsVerification: fyorin?.status == 'Pending',
    }
}

const mapDispatchToProps = (dispatch) => ({
    connect: () => dispatch(FYORINACTIONS.connectFyorin()),
    disconnect: () => dispatch(FYORINACTIONS.disconnectFyorin()),
    verifyConnection: () => dispatch(FYORINACTIONS.verifyConnection())
})

export default connect(mapStateToProps, mapDispatchToProps)(FyorinSettings)
